import { useEffect, useState } from "react";
import { Col, Row } from "react-bootstrap";
import CommonModal from "../../components/shared/modalLayout/CommonModal";
import InputWithLabel from "../../components/shared/fields/InputWithLabel";
import Button from "../../components/shared/buttons/button";
import useTranslator from "../../hooks/useTranslator";
import { useCreateMixingPendingMutation } from "./mixingApi";

const MixingPendingModal = ({ show, setShow, batchCode ,record}) => {
 
  const { _t } = useTranslator();

  const [formData, setFormData] = useState({
    material_unit: record?.material_unit ?? 0,
    description:   record?.material_description ?? "",
  });

  const [createMixingPending, { isLoading: isCreating }] = useCreateMixingPendingMutation();

  useEffect(() => {
    if (show) {
      setFormData({
        material_unit: record?.material_unit ?? "",
        description:   record?.material_description ?? "",
      });
    }
  }, [show, record]);

  const handleClose = () => setShow(false);

  const handleChange = (e) => {
    const { name, value } = e.target;
    setFormData((p) => ({ ...p, [name]: value }));
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    if (isCreating) return;
    try {
      await createMixingPending({
        batch_code:    batchCode ? String(batchCode) : "",
        material_unit: parseFloat(formData.material_unit) || 0,
        description:   formData.description || "",
      }).unwrap();
      handleClose();
    } catch (err) {
      console.error("Error saving mixing pending:", err);
    }
  };

  return (
    <CommonModal
      show={show}
      handleClose={handleClose}
      setShow={setShow}
      title={_t("add_mixing_pending", "Add Mixing Pending")}
      className={"sm-modal"}
    >
      <Row>
        {/* Weight In KG */}
        <Col lg={12}>
          <InputWithLabel
            label={_t("weight_in_kg", "Weight In KG")}
            type="number"
            name="material_unit"
            value={formData.material_unit}
            onChange={handleChange}
            placeholder="0"
          />
        </Col>

        {/* Description (optional) */}
        <Col lg={12}>
          <InputWithLabel
            label={`${_t("description", "Description")} (${_t("optional", "Optional")})`}
            type="text"
            name="description"
            value={formData.description}
            onChange={handleChange}
            placeholder={_t("description", "Description")}
          />
        </Col>
      </Row>

      <Row>
        <Col className="text-end">
          <Button
            label={_t("save_changes", "Save Changes")}
            size="small"
            onClick={handleSubmit}
            disabled={isCreating}
          />
        </Col>
      </Row>
    </CommonModal>
  );
};

export default MixingPendingModal;
